import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../shared/services/snackbar/snackbar.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SelectOptions } from '../../core/interfaces/select-options.interface';
import { MatDividerModule } from '@angular/material/divider';
import { DownloadResourcesService } from '../../core/services/download-resources/download-resources.service';
import { GetDownloadResourceListModel } from '../../core/models/get-download-resource-list/get-download-resource-list.model';
import { HttpStatusCode } from 'axios';
import { DownloadResourceList } from '../../core/interfaces/download-resource-list.interface';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { UserLogService } from '../../core/services/user-log/user-log.service';
import { Router } from '@angular/router';
import { ConstantsService } from '../../core/services/constants/constants.service';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { DownloadResourceCategory } from '../../core/interfaces/download-resource-category.interface';
type View = 'root' | 'split' | 'client' | 'event' | 'files';
@Component({
  selector: 'app-download-resources',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule,
    MatPaginatorModule,
    MatIconModule
  ],
  templateUrl: './download-resources.page.html',
  styleUrl: './download-resources.page.scss'
})
export class DownloadResourcesPage implements OnInit, AfterViewInit {
  private router = inject(Router);
  private formBuilder = inject(FormBuilder);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private downloadResourcesService = inject(DownloadResourcesService);
  private userLogService = inject(UserLogService);
  private constantsService = inject(ConstantsService);

  protected downloadResourceCategoryOptions: SelectOptions[] = [];
  protected getDownloadResourceListModel = new GetDownloadResourceListModel();
  protected resourceCategoryList: DownloadResourceCategory[] = [];
  protected resourceCategoryListDataSource: DownloadResourceCategory[] = [];
  protected resourceCategoryListSelectionPath: DownloadResourceCategory[] = [];
  protected downloadResourceListDataSource: DownloadResourceList[] = [];
  protected downloadResourceList: DownloadResourceList[] = [];
  protected tempDownloadResourceList: DownloadResourceList[] = [];
  protected downloadResourcePageSize: number = 10;
  protected downloadResourceCurrentPage: number = 0;
  protected downloadResourceLength: number = 0;
  protected selectedCategoryId: number = 0;

  private readonly ROOT_RESOURCE_CATEGORY: DownloadResourceCategory = {
    resourceCategoryId: 0,
    parentResourceCategoryId: 0,
    resourceCategoryName: 'Category'
  };


  protected setResourceListSprinner = signal(false);
  protected categoryIdSelection = signal(0);
  protected isCategoryListNotEmpty = signal(false);

  @ViewChild(MatPaginator)
  downloadResourcePaginator!: MatPaginator;

  downloadResourceFg!: FormGroup;

  constructor() { }

  async ngOnInit(): Promise<void> {
    this.downloadResourceFg = this.formBuilder.group({
      searchKeyword: [''],
      // drCategory: ['']
    });

    this.resourceCategoryListSelectionPath.push(this.ROOT_RESOURCE_CATEGORY);

    await this.getdownloadResourceCategoryList();

    // await this.getDownloadResourceList();

    this.__applyDownloadResourceFilter();
  }

  ngAfterViewInit(): void { }

  async getdownloadResourceCategoryList() {
    // const responseData = await this.constantsService
    //   .getConstantsList()
    //   .then((response) => {
    //     return JSON.parse(response);
    //   })
    //   .catch((error) => {
    //     // console.error(error);
    //     return error;
    //   });

    // const categoryList: any[] = responseData.data.responsedata.categories;

    // this.downloadResourceCategoryOptions = [];
    // categoryList.forEach((category) => {
    //   this.downloadResourceCategoryOptions.push({
    //     name: category,
    //     value: category
    //   });
    // });

    const responseData = await this.downloadResourcesService
      .getDownloadResourceCategoryList()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      this.resourceCategoryList = responseData.data.responsedata;
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

      this.sessionStorageService.clearSessionStorage();
    }

    this.__applyDownloadResourceCategoryListFilter(0);

    await this.getDownloadResourceList(0);
  }

  async getDownloadResourceList(resourceCategoryId: number) {
    this.setResourceListSprinner.set(true);

    const responseData = await this.downloadResourcesService
      .getDownloadResourceList(resourceCategoryId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setResourceListSprinner.set(false);

    // Handling the response from the API call.
    if (responseData.status === HttpStatusCode.Ok) {
      // this.downloadResourceList = responseData.data.responsedata.getallresourcecategoryrow;
      let drList: DownloadResourceList[] = responseData.data.responsedata.getallresourcecategoryrow;

      drList.forEach((item) => {
        item.resourceCategoryPath = this.__getCategoryPath(item);
      });

      this.downloadResourceList = drList;

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

      this.sessionStorageService.clearSessionStorage();
    }
  }

  protected async __onCategorySelection(category: DownloadResourceCategory) {
    this.categoryIdSelection.set(category.resourceCategoryId);
    this.selectedCategoryId = category.resourceCategoryId;
    this.__applyDownloadResourceCategoryListFilter(category.resourceCategoryId);

    this.resourceCategoryListSelectionPath = [];

    let tempCategorySelectionList: DownloadResourceCategory[] = [];

    if (category.resourceCategoryId != 0) {

      let parentCategoryId: number = category.parentResourceCategoryId;
      tempCategorySelectionList.push(category);

      while (parentCategoryId != 0) {
        let parentCategory = this.resourceCategoryList.find(item => item.resourceCategoryId == parentCategoryId);

        if (parentCategory) {
          tempCategorySelectionList.push(parentCategory);
          parentCategoryId = parentCategory?.parentResourceCategoryId;
        }
      }
    }

    tempCategorySelectionList.push(this.ROOT_RESOURCE_CATEGORY);

    this.resourceCategoryListSelectionPath = tempCategorySelectionList.reverse();

    // await this.getDownloadResourceList(category.resourceCategoryId);
    this.__applyDownloadResourceFilter();
  }

  protected __getCategoryPath(drItem: DownloadResourceList) {
    let categoryPath: string[] = [drItem.resourceCategoryName.toLowerCase()];
    let pathString: string = drItem.resourceCategoryName;

    let parentCategoryId = this.resourceCategoryList.find((item) => item.resourceCategoryId == drItem.resourceCategoryId)?.parentResourceCategoryId;

    while (parentCategoryId != 0) {
      let parentCategory = this.resourceCategoryList.find((item) => item.resourceCategoryId == parentCategoryId)

      if (parentCategory) {
        pathString = parentCategory.resourceCategoryName + '\t›\t' + pathString;

        categoryPath.push(parentCategory.resourceCategoryName.toLowerCase());

        parentCategoryId = parentCategory.parentResourceCategoryId;
      }
    }


    return pathString;
  }

  protected __applyDownloadResourceCategoryListFilter(parentCategoryId: number) {
    this.resourceCategoryListDataSource = this.resourceCategoryList.filter((item) => item.parentResourceCategoryId == parentCategoryId);

    if (this.resourceCategoryListDataSource.length != 0) {
      this.isCategoryListNotEmpty.set(true);
    } else {
      this.isCategoryListNotEmpty.set(false);
    }
  }

  protected __applyDownloadResourceFilter() {
    let searchKeyword: string = this.downloadResourceFg.get('searchKeyword')?.value.toString();

    let targetCategoryIds: number[] = [this.selectedCategoryId];

    this.resourceCategoryList.forEach((category) => {
      if (targetCategoryIds.includes(category.parentResourceCategoryId)) {
        targetCategoryIds.push(category.resourceCategoryId);
      }
    });

    let targetDownloadResources: DownloadResourceList[] = this.downloadResourceList
      .filter((item) => (targetCategoryIds.includes(item.resourceCategoryId)));

    if (searchKeyword) {
      this.tempDownloadResourceList = targetDownloadResources
        .filter(drItem =>
          drItem.resourceTitle.toLowerCase().includes(searchKeyword.toLowerCase())
          // || drItem.resourceCategoryName.toLowerCase().includes(searchKeyword.toLowerCase())
          || drItem.resourceCategoryPath.toLowerCase().includes(searchKeyword.toLowerCase())
        );
    } else {
      this.tempDownloadResourceList = targetDownloadResources;
    }

    this.downloadResourcePaginator.firstPage();
    this.__downloadResourceUpdatePageItems();
  }

  protected __downloadResourceUpdatePageItems() {
    const startIndex: number = this.downloadResourceCurrentPage * this.downloadResourcePageSize;
    const endIndex: number = startIndex + this.downloadResourcePageSize;
    this.downloadResourceLength = this.tempDownloadResourceList.length;

    if (this.downloadResourceLength < this.downloadResourcePageSize) {
      this.downloadResourcePaginator.disabled = true;
    }
    else {
      this.downloadResourcePaginator.disabled = false;
    }

    this.downloadResourceListDataSource = this.tempDownloadResourceList.slice(startIndex, endIndex);
  }

  protected __downloadResourceOnPageChange() {
    this.downloadResourcePageSize = this.downloadResourcePaginator.pageSize;
    this.downloadResourceCurrentPage = this.downloadResourcePaginator.pageIndex;
    this.__downloadResourceUpdatePageItems();
  }

  protected __getFileType(resourceLink: string) {
    let fileUrlName: string[] = resourceLink.split(".");
    return fileUrlName[fileUrlName.length - 1];
  }

  protected async __userLogDocument(resourceId: number, resourceLink: string) {
    let fileUrlName: string[] = resourceLink.split("/");
    await this.downloadResourcesService.downloadResourceFile(resourceId, fileUrlName[fileUrlName.length - 1]);
    await this.userLogService.logUserDownloadResource(fileUrlName[fileUrlName.length - 1]);
  }

  protected clearSearch() {
    this.downloadResourceFg.get('searchKeyword')?.setValue('');
    this.__applyDownloadResourceFilter();
  }

  protected async __printDownloadResource(resourceId: number) {
    await this.downloadResourcesService.printPdf(resourceId);
  }
  onPillClick(event: MouseEvent, category: any) {
    event.stopPropagation(); //  block accordion toggle
    this.__onCategorySelection(category);
  }

}


